// extracted by mini-css-extract-plugin
export var featuredProducts = "featured-products-module--featuredProducts--82624";
export var productsHeading = "featured-products-module--productsHeading--e8e20";